import { normalize } from 'normalizr';
import { takeLatest, call, put, select } from 'redux-saga/effects';

import { theme, createStandaloneToast } from '@frontend/components';

import service from 'services/opDefService';

import { selectors as sessionSelectors } from 'store/session';

import { getErrorMessage } from 'utils/stringUtils';

import * as actions from './actions';
// import type {
//   UpdateOpDefRequestAction,
//   UpdateVariableRequestAction,
//   UpdateFormulaRequestAction,
//   CompileFormulaRequestAction,
//   SearchOpDefsRequestAction,
// } from './actions';
import * as entities from './entities';

const { types } = actions;
const { toast } = createStandaloneToast({ theme });

export default function* root() {
  yield takeLatest(types.FETCH_MANUFACTURERS_REQUEST, watchFetchManufacturers);
  yield takeLatest(types.FETCH_MACHINES_REQUEST, watchFetchMachines);
  yield takeLatest(types.UPDATE_OPDEF_REQUEST, watchUpdateOpDef);
  yield takeLatest(types.UPDATE_VARIABLE_REQUEST, watchUpdateVariable);
  yield takeLatest(types.UPDATE_FORMULA_REQUEST, watchUpdateFormula);
  yield takeLatest(types.COMPILE_FORMULA_REQUEST, watchCompileFormula);
  yield takeLatest(types.SEARCH_OP_DEFS_REQUEST, watchSearchOpDefs);
}

function* watchFetchManufacturers(action) {
  try {
    const { processClassId } = action.payload;
    const response = yield call(service.listManufacturers, processClassId);
    yield put(
      actions.fetchManufacturers.success({
        processClassId,
        manufacturers: response,
      }),
    );
  } catch (error) {
    yield put(actions.fetchManufacturers.error(error));
  }
}

function* watchFetchMachines(action) {
  try {
    const { processClassId, manufacturerId } = action.payload;
    const response = yield call(
      service.listMachines,
      processClassId,
      manufacturerId,
    );
    yield put(
      actions.fetchMachines.success({
        processClassId,
        manufacturerId,
        machines: response,
      }),
    );
  } catch (error) {
    yield put(actions.fetchMachines.error(error));
  }
}

export function* watchUpdateOpDef(action) {
  try {
    const { opDefId, data } = action.payload;
    const groupId = yield select(sessionSelectors.getGroupId);
    const response = yield call(service.updateOpDef, groupId, opDefId, data);
    yield put(actions.updateOpDef.success(response));
  } catch (error) {
    yield put(actions.updateOpDef.error(error));
    toast({
      title: 'Error',
      status: 'error',
      description: getErrorMessage(error),
    });
  }
}

function* watchUpdateVariable(action) {
  try {
    const { variableId, data } = action.payload;
    const response = yield call(service.updateVariable, variableId, data);
    yield put(actions.updateVariable.success(response));
  } catch (error) {
    yield put(actions.updateVariable.error(error));
    toast({
      title: 'Error',
      status: 'error',
      description: getErrorMessage(error),
    });
  }
}

function* watchUpdateFormula(action) {
  try {
    const { opDefId, formula, revertedFrom } = action.payload;
    const response = yield call(
      service.updateOpDefFormula,
      opDefId,
      formula,
      revertedFrom,
    );
    yield put(actions.updateFormula.success(opDefId, response));
  } catch (error) {
    yield put(actions.updateFormula.error(error));
  }
}

function* watchCompileFormula(action) {
  try {
    const { formula, version } = action.payload;
    const supplierId = yield select(sessionSelectors.getGroupId);
    yield call(service.compileFormula, formula, version, supplierId);
    yield put(actions.compileFormula.success());
  } catch (error) {
    yield put(actions.compileFormula.error(error));
  }
}

function* watchSearchOpDefs(action) {
  try {
    const { query } = action.payload;
    const groupId = yield select(sessionSelectors.getGroupId);
    const response = yield call(service.listOpDefs, groupId, query);
    yield put(actions.searchOpDefs.success(response));
  } catch (error) {
    yield put(actions.searchOpDefs.error());
    yield call(
      toast({
        title: 'Error',
        status: 'error',
        description: getErrorMessage(error),
      }),
    );
  }
}

export function* fetchOpDefs() {
  const groupId = yield select(sessionSelectors.getGroupId);
  const response = yield call(service.listOpDefs, groupId);
  yield put(actions.addOpDefsToStore({ opDefs: response }));

  const { result } = normalize(response, [entities.opDefSchema]);
  return result;
}
